import { controllersEnum } from '@/logic/controllers';
import { LogicContext } from '@/logic/main/types';

export const setRouteDynamicActionData = async (context: LogicContext) => {
  const [, entry] =
    context?.controllersData?.[controllersEnum.DYNAMIC_ROUTE_ACTION]
      ?.components?.[0] || [];

  return {
    routeDynamicAction: entry?.properties?.action,
  };
};
